import { createStore } from 'vuex'

import mutations from './mutations';
import getters from './getters';
import actions from './actions';

const state = {
  degreePrograms: [],
  userDegreeType: null,
  degreeType: [],
  militaryStatus: [],
  regions: [],
  degreeOptions: [],
  courseModality: [],
  schoolSize: [],
  hbcuOptions: [],
  userSdnAgree: false,
  discountNumber: null,
  notifications: []
}

export default createStore({
  state,
  actions,
  getters,
  mutations
})
